// 轻量预加载工具：缓存 Promise，避免重复请求与内存泄漏
const imagePromiseCache = new Map();

export function preloadImage(src, { timeoutMs = 10000 } = {}) {
  if (!src) return Promise.resolve(false);
  if (imagePromiseCache.has(src)) return imagePromiseCache.get(src);

  const p = new Promise((resolve) => {
    const img = new Image();
    let done = false;
    let timer = null;

    const cleanup = () => {
      img.onload = null;
      img.onerror = null;
      if (timer) {
        clearTimeout(timer);
        timer = null;
      }
    };

    const finish = (ok) => {
      if (done) return;
      done = true;
      cleanup();
      resolve(ok);
    };

    img.decoding = 'async';
    img.onload = () => finish(true);
    img.onerror = () => finish(false);
    img.src = src;

    if (timeoutMs > 0) {
      timer = setTimeout(() => finish(false), timeoutMs);
    }
  });

  imagePromiseCache.set(src, p);
  return p;
}

export function preloadImages(srcList, opts) {
  if (!Array.isArray(srcList) || srcList.length === 0) return Promise.resolve([]);
  return Promise.all(srcList.map((s) => preloadImage(s, opts)));
}

